import React, {useContext} from 'react';

import {ScreenLocker} from '../../features/Form/components/ScreenLocker';
import {CustomQueryClientProvider} from '../../hooks/useQueryClientProvider';
import {AppSearchesContext} from './AppSearchesContext';
import AppSearchesButton from './componenets/AppSearchButton';
import AppSearchesDialog from './componenets/AppSearchesDialog';
import {useAppsearches} from './useAppSearches';

const AppSearchesComp = () => {
    const contextValue = useAppsearches();

    return (
        <AppSearchesContext.Provider value={contextValue}>
            <AppSearchContent />
        </AppSearchesContext.Provider>
    );
};

const AppSearchContent = () => {
    const {isOpen, isLoading, formSession, handleCancelQueries} = useContext(AppSearchesContext);
    return (
        <>
            {isLoading && (
                <ScreenLocker
                    toggleLoader={handleCancelQueries}
                    showLoader={isLoading}
                    locked={isLoading}
                />
            )}
            <AppSearchesButton />
            {isOpen && !isLoading && !!formSession && <AppSearchesDialog />}
        </>
    );
};

export const AppSearches = () => {
    return (
        <CustomQueryClientProvider>
            <AppSearchesComp />
        </CustomQueryClientProvider>
    );
};
